import React, { Component } from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography,
  Divider,
  TextField,
  Chip
} from "@material-ui/core";

import request from "superagent";
import { defaultPaperPadding, url_endpoint, url_s3, urlPlayer } from "../../../config";
import authHeader from "../../Utils/AuthHeader";
import { PlayArrow, Pause, VerticalAlignCenter, RadioButtonUnchecked } from "@material-ui/icons";
import ReactAudioPlayer from "react-audio-player";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import { withStyles } from "@material-ui/core/styles";

import LoaderSpinner from "../../../componentes/LoaderSpinner";
import iconAgredSpotfi from "../../../images/agregadores/spotify.png";
import iconAgredGoogle from "../../../images/agregadores/google.png";
import iconAgredItunes from "../../../images/agregadores/itunes.png";
import FirebaseService from "../../../services/FirebaseService";

import { textAlign } from "@material-ui/system";
import checkLogin from "../../Utils/checkLogin";
import palette from "../../../theme/palette";
import ImageIconBox from "../components/ImageIconBox";
import PlayIcon from '../../../images/icons/play_icon.svg'
import ShareIcon from '../../../images/icons/share_icon.svg'
import DownloadIcon from '../../../images/icons/download_icon.svg'
import SpotifyIcon from '../../../images/icons/spotify_icon.svg'
import ItunesIcon from '../../../images/icons/itunes_icon.svg'
import GoogleIcon from '../../../images/icons/google_icon.svg'
import WhatsappIcon from '../../../images/icons/whatsapp_icon.svg'
import FacebookIcon from '../../../images/icons/facebook_icon.svg'
import TwitterIcon from '../../../images/icons/twitter_icon.svg'
import LinkedinIcon from '../../../images/icons/linkedin_icon.svg'
import LogoBlogplay from '../../../images/logo_blogplay_color.svg'
const moment = require("moment");

const useStyles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    // padding: theme.spacing(1),
    // color: theme.palette.text.secondary,

    // minHeight: "100px",
    // textAlign: "center",
  },
  player: {
    backgroundColor: "white",
    padding: theme.spacing(1),
    color: "#fff",

    display: "grid",
    height: "85px",
    textAlign: "center",
    borderRadius: '10px'
  },
  spotify: {
    backgroundColor: "white",
    padding: theme.spacing(1),
    color: "#fff",

    display: "grid",
    height: "85px",
    textAlign: "center",
    borderRadius: '10px'
  },
  itunes: {
    backgroundColor: "white",
    padding: theme.spacing(1),
    color: "#fff",
    display: "grid",

    height: "85px",
    textAlign: "center",
    borderRadius: '10px'
  },
  google: {
    backgroundColor: "white",
    padding: theme.spacing(1),
    color: "#fff",

    display: "grid",
    height: "85px",
    textAlign: "center",
    borderRadius: '10px'
  },
  whatsapp: {
    backgroundColor: "white",
    padding: theme.spacing(1),
    color: "#fff",

    height: "85px",
    display: "grid",
    textAlign: "center",
    borderRadius: '10px'
  },
  facebook: {
    backgroundColor: "white",
    padding: theme.spacing(1),
    color: "#fff",

    display: "grid",
    height: "85px",
    textAlign: "center",
    borderRadius: '10px'
  },
  twitter: {
    backgroundColor: "white",
    padding: theme.spacing(1),
    color: "#fff",

    display: "grid",
    height: "85px",
    textAlign: "center",
    borderRadius: '10px'
  },
  linkedin: {
    backgroundColor: "white",
    padding: theme.spacing(1),
    color: "#fff",

    height: "85px",
    textAlign: "center",
    display: "grid",
    borderRadius: '10px'
  },

  totalReproducao: {
    padding: theme.spacing(1),
    color: "#737373",

    textAlign: "center",
    height: "100%",
    display: "grid",
    border: '1px solid #737373',
    borderRadius: '10px'
  },
});
class Details extends Component {
  constructor(props) {
    super(props);

    this.state = {
      audioUrl: '',
      podcast: {
        status_itunes: false,
        status_google: false,
        status_spotify: false,
      },
      title: '',
      Cliente: {},
      motivo: "",
      tempo_total: 0,
      tempo_atual: 0,
      progressbar: 0,
      playing: false,
      loading: false,
      openDialog: false,
      isExcluir: false,
      openDialogAlert: false,
      message_alert: "",
      startDate: moment().startOf("day").toDate().getTime(),
      endDate: moment().endOf("day").toDate().getTime(),
      reprodPlayer: 0,
      openPlaySpotify: 0,
      openPlayItunes: 0,
      openPlayGoogle: 0,
      shareWhatsapp: 0,
      shareFacebook: 0,
      shareTwitter: 0,
      shareLinkedin: 0,
      totalReproducao: 0,
      totalDownload: 0,
      totalShare: 0,
      vsPlayer: 1,
      datePedido: null,
    };

    props.setTitulo("Detalhes");
  }

  handleClose = () => {
    this.setState({ openDialog: false });
  };

  handleCloseAlert = () => {
    this.setState({ openDialogAlert: false });
  };
  handleOpenAlert = (message) => {
    this.setState({ openDialogAlert: true, message_alert: message });
  };

  mmss(secs) {
    secs = parseInt(secs);
    const minutes = Math.floor(secs / 60);
    secs = secs % 60;
    return `${this.pad(minutes)}:${this.pad(secs)}`;
  }
  pad(num) {
    return ("0" + num).slice(-2);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  async componentDidMount() {
    try {
      this.setState({ loading: true });
      await checkLogin(false)
      const res = await request
        .get(url_endpoint + "podcast/" + this.props.match.params.id)
        .set(authHeader());
      const resCli = await request
        .get(url_endpoint + "cliente/me")
        .set(authHeader());

      this.setState({ loading: false });
      const vsPlayer = moment().format("YYMMDD");
      await this.setState({
        audioUrl: res.body.arquivo.includes('digitalocean') ? res.body.arquivo : url_s3 + res.body.arquivo,
        podcast: res.body,
        title: res.body.titulo,
        Cliente: resCli.body,
        vsPlayer: vsPlayer,
      });

      if (res.body.Pedido != null && res.body.Pedido != undefined) {
        this.setState({
          datePedido: new Date(res.body.Pedido.createdAt),
        })
      }

      this.props.setTitulo(`Detalhes`)

      this.checkStatusAgregadores();
      let totalShare = 0,
        totalReproducao = 0,
        totalDownload = 0;

      try {
        //recupera todos os shares
        FirebaseService.getDadosPlayer(
          this.props.match.params.id,
          "share_whatsapp",
          (rest) => {
            if (rest) totalShare = this.state.totalShare + rest;

            this.setState({ shareWhatsapp: rest, totalShare: totalShare });
          }
        );
      } catch (error) {
        console.log(error);
      }
      try {
        //recupera todos os shares
        FirebaseService.getDadosPlayer(
          this.props.match.params.id,
          "share_facebook",
          (rest) => {
            if (rest) totalShare = this.state.totalShare + rest;

            this.setState({ shareFacebook: rest, totalShare: totalShare });
          }
        );
      } catch (error) {
        console.log(error);
      }
      try {
        //recupera todos os shares
        FirebaseService.getDadosPlayer(
          this.props.match.params.id,
          "share_linkedin",
          (rest) => {
            if (rest) totalShare = this.state.totalShare + rest;

            this.setState({ shareLinkedin: rest, totalShare: totalShare });
          }
        );
      } catch (error) {
        console.log(error);
      }

      try {
        //recupera todos os shares
        FirebaseService.getDadosPlayer(
          this.props.match.params.id,
          "share_twitter",
          (rest) => {
            if (rest) totalShare = this.state.totalShare + rest;

            this.setState({ shareTwitter: rest, totalShare: totalShare });
          }
        );
      } catch (error) {
        console.log(error);
      }

      try {
        FirebaseService.getDadosPlayer(
          this.props.match.params.id,
          "play",
          (rest) => {
            if (rest) totalReproducao = this.state.totalReproducao + rest;

            this.setState({
              reprodPlayer: rest,
              totalReproducao: totalReproducao,
            });
          }
        );
      } catch (error) {
        console.log(error);
      }

      try {
        FirebaseService.getDadosPlayer(
          this.props.match.params.id,
          "download",
          (rest) => {
            if (rest) totalDownload = this.state.totalDownload + rest;

            this.setState({ totalDownload: totalDownload });
          }
        );
      } catch (error) {
        console.log(error);
      }

      try {
        FirebaseService.getDadosPlayer(
          this.props.match.params.id,
          "agregador_itunes",
          (rest) => {
            if (rest) {
              totalReproducao = this.state.totalReproducao + rest;
              this.setState({
                totalReproducao: totalReproducao,
                openPlayItunes: rest,
              });
            }
          }
        );
      } catch (error) {
        console.log(error);
      }

      try {
        FirebaseService.getDadosPlayer(
          this.props.match.params.id,
          "agregador_spotify",
          (rest) => {
            if (rest) {
              totalReproducao = this.state.totalReproducao + rest;
              this.setState({
                totalReproducao: totalReproducao,
                openPlaySpotify: rest,
              });
            }
          }
        );
      } catch (error) {
        console.log(error);
      }

      try {
        FirebaseService.getDadosPlayer(
          this.props.match.params.id,
          "agregador_google",
          (rest) => {
            if (rest) {
              totalReproducao = this.state.totalReproducao + rest;
              this.setState({
                totalReproducao: totalReproducao,
                openPlayGoogle: rest,
              });
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    } catch (err) {
      this.setState({ loading: false });
      this.handleOpenAlert(err);
    }

    this.interval = setInterval(() => {
      try {
        const current = this.player.audioEl.currentTime;
        const progressbar = (current * 100) / this.player.audioEl.duration;
        this.setState({ tempo_atual: this.mmss(current), progressbar });
      } catch (e) { }
    }, 20);
  }

  changeTime = (evt) => {
    const positionClicked = evt.clientX - evt.currentTarget.offsetLeft;

    const timeSelected =
      (positionClicked * this.player.audioEl.duration) /
      evt.currentTarget.clientWidth;
    this.player.audioEl.currentTime = timeSelected;
    //console.log(evt)
  };

  togglePlay = () => {
    if (this.state.playing) this.player.audioEl.pause();
    else this.player.audioEl.play();
    this.setState({ playing: !this.state.playing });
  };

  reject = () => {
    this.setState({ openDialog: true, isExcluir: false });
  };

  checkStatusAgregadores = async () => {
    const podcast = this.state.podcast;

    if (
      (podcast.url_post_spotify && podcast.url_post_spotify.length > 0) ||
      (this.state.Cliente.url_post_spotify &&
        this.state.Cliente.url_post_spotify.length > 0)
    )
      podcast.status_spotify = true;

    if (
      (podcast.url_post_itunes && podcast.url_post_itunes.length > 0) ||
      (this.state.Cliente.url_post_itunes &&
        this.state.Cliente.url_post_itunes.length > 0)
    )
      podcast.status_itunes = true;

    if (
      (podcast.url_post_google && podcast.url_post_google.length > 0) ||
      (this.state.Cliente.url_post_google &&
        this.state.Cliente.url_post_google.length > 0)
    )
      podcast.status_google = true;

    this.setState({ podcast });
  };

  accept = async () => {
    try {
      this.setState({ loading: true });
      await request
        .patch(url_endpoint + "podcast/" + this.state.podcast.id)
        .send({ status: 2, title: this.state.podcast.titulo })
        .set(authHeader());
      const podcast = this.state.podcast;
      this.setState({ loading: false });
      podcast.status = 2;
      this.setState({ podcast });
    } catch (err) {
      this.setState({ loading: false });
      console.log(err);
    }
  };
  changeTitulo = async (evt) => {
    clearTimeout(this.changeTituloTimeout);
    evt.persist();
    const podcast = this.state.podcast;
    const newTitle = evt.target.value
    podcast.titulo = newTitle;
    this.setState({ podcast, title: newTitle });
    this.changeTituloTimeout = setTimeout(async (_) => {
      try {
        await request
          .patch(url_endpoint + "podcast/titulo/" + this.state.podcast.id)
          .send({ titulo: newTitle })
          .set(authHeader());
      } catch (err) {
        console.log(err);
      }
    }, 1000);
  };
  changeObs = async (evt) => {
    clearTimeout(this.changeObsTimeout);
    evt.persist();
    const podcast = this.state.podcast;
    podcast.obs = evt.target.value;
    this.setState({ podcast });
    this.changeObsTimeout = setTimeout(async (_) => {
      try {
        await request
          .patch(url_endpoint + "podcast/obs/" + this.state.podcast.id)
          .send({ obs: evt.target.value })
          .set(authHeader());
      } catch (err) {
        console.log(err);
      }
    }, 1000);
  };
  changeFrom = async (evt) => {
    const podcast = this.state.podcast;
    podcast.apos = evt.target.value;
    this.setState({ podcast });
    if (evt.target.value.length >= 10) {
      try {
        await request
          .patch(url_endpoint + "podcast/apos/" + this.state.podcast.id)
          .send({ apos: evt.target.value })
          .set(authHeader());
      } catch (err) {
        console.log(err);
      }
    }
  };
  deleteB = async () => {
    this.setState({ openDialog: true, isExcluir: true });
  };

  clickImage = () => {
    // this.imagem.click();
  };
  changeImage = (evt) => {
    evt.preventDefault()
  };

  openLinkAgregador = (url) => {
    if (url && url.length > 0) window.open(url, "_blank");
  };
  publicarAgregadores = async () => {
    try {
      if (!this.state.podcast.agregar) {
        const podcast = this.state.podcast;
        podcast.agregar = true;
        this.setState({ loading: true, podcast: podcast });

        await request
          .patch(
            url_endpoint + "podcast/publicar_agregador/" + this.state.podcast.id
          )
          .send({ agregar: true })
          .set(authHeader());
        this.setState({ loading: false });

        ///Postagem nos agregadores feita com sucessso!  A aprovacao do episodio pode levar ate 48 horas
        this.handleOpenAlert(
          "Postagem nos agregadores feita com sucesso! \nA aprovação do episódio pode levar até 48 horas."
        );
      } else {
        this.handleOpenAlert(
          "Já foi solicitado para publicar nos agregadores!"
        );

        //alert("Já foi solicitado para publicar nos agregadores!");
      }
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
    }
  };
  confirmarDesistencia = async () => {
    try {
      this.setState({ openDialog: false });

      this.setState({ loading: true });
      if (!this.state.isExcluir) {
        await request
          .patch(url_endpoint + "podcast/" + this.state.podcast.id)
          .send({ status: 1, motivo: this.state.motivo, title: this.state.podcast.titulo })
          .set(authHeader());
        this.setState({ loading: false, motivo: "" });
        const podcast = this.state.podcast;
        podcast.status = 1;
        await this.setState({ podcast });

        this.checkStatusAgregadores();
      } else {
        this.setState({ isExcluir: false });

        try {
          await request
            .patch(url_endpoint + "podcast/" + this.state.podcast.id)
            .send({ status: 3, motivo: this.state.motivo })
            .set(authHeader());
          window.location = "/painel";
        } catch (error) {
          console.log(error);
          this.setState({ loading: false });
          this.handleOpenAlert("Erro ao remover o áudio!");
        }
      }
    } catch (err) {
      this.setState({ loading: false });
      console.log(err);
    }
  };

  changeMotivo = async (evt) => {
    evt.persist();
    this.setState({ motivo: evt.target.value });
  };

  buildCompleteAnalyticsCard(title, value, description, icon) {
    return <Paper style={{
      position: 'relative',
      width: '30%',
      padding: '10px 20px',
      color: 'grey',
      textAlign: 'start',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center'
    }}>
      <ImageIconBox style={{ position: 'absolute', top: '10px', right: '15px' }} src={icon}></ImageIconBox>
      <div style={{ width: '100%', borderLeft: `3px ${palette.primary.main} solid`, padding: '5px 7px' }}>
        <h3 style={{ fontWeight: '500', paddingRight: '15px' }}>{title}</h3>
        <h1 style={{ marginTop: '5px' }}>{value}</h1>
      </div>
      <h3 style={{ marginTop: '5px', color: 'lightgrey' }}>{description}</h3>
    </Paper>
  }

  buildSimpleAnalyticsCard(title, value, description, icon) {
    return <Paper style={{
      position: 'relative',
      width: '200px',
      padding: '10px 20px',
      color: 'grey',
      textAlign: 'start',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center'
    }}>
      <img style={{ position: 'absolute', top: '10px', right: '15px', width: '30px', height: '30px' }} src={icon}></img>
      <div style={{ width: '100%', padding: '5px 7px' }}>
        <h3 style={{ fontWeight: '500', paddingRight: '15px' }}>{title}</h3>
        <h1 style={{ marginTop: '5px' }}>{value}<span style={{ color: 'lightgrey', fontSize: '13px', marginLeft: '5px' }}>{description}</span></h1>
      </div>
    </Paper>
  }

  render() {
    const iframeSize =
      parseInt(this.state.Cliente.layout) === 3 ? "122px;" : "180px;";
    const iframecode =
      "<iframe src='" +
      urlPlayer +
      "/player/" +
      this.state.podcast.id +
      "?v=" +
      this.state.vsPlayer +
      "' style='height: " +
      iframeSize +
      " min-width: 100%; border:none;'></iframe>";
    const { classes } = this.props;

    let width = window.innerWidth
    window.onresize = () => {
      width = window.innerWidth
      this.setState({})
    }

    let isMobile = width < 960

    return (
      <div style={{ width: "100%" }}>
        {this.state.loading && <LoaderSpinner />}

        <Dialog
          open={this.state.openDialogAlert}
          onClose={this.handleCloseAlert}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            {"Atenção"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>{this.state.message_alert}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.handleCloseAlert} color="primary">
              {"OK"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleClose}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            {this.state.isExcluir
              ? "Informe o motivo da exclusão!"
              : "Înforme o que deseja alterar!"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <textarea
                value={this.state.motivo}
                onChange={this.changeMotivo}
                placeholder="Digite aqui!"
                maxLength={250}
                style={{ width: "400px", height: "120px", color: "#5f5f5f" }}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.handleClose} color="primary">
              {"Fechar"}
            </Button>
            <Button onClick={this.confirmarDesistencia} color="primary">
              {"Confirmar"}
            </Button>
          </DialogActions>
        </Dialog>

        {isMobile == false &&
          <img style={{ position: 'absolute', top: '64px', right: '0', left: '0', width: '100%', height: '160px', objectFit: 'cover', objectPosition: 'center', filter: 'blur(1px)' }} src={(this.state.podcast.imagem != null && this.state.podcast.imagem != '') ? this.state.podcast.imagem.includes('digitalocean') ? this.state.podcast.imagem : url_s3 + this.state.podcast.imagem : LogoBlogplay}></img>
        }

        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={4} lg={3} xl={3} style={{ marginBottom: "5px", zIndex: 1 }}>
            <Paper style={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: defaultPaperPadding }}>
              <img style={{ width: "100%", height: "260px", borderRadius: '10px' }} src={(this.state.podcast.imagem != null && this.state.podcast.imagem != '') ? this.state.podcast.imagem.includes('digitalocean') ? this.state.podcast.imagem : url_s3 + this.state.podcast.imagem : LogoBlogplay}></img>

              <input
                type={"file"}
                onChange={this.changeImage}
                ref={(ref) => (this.imagem = ref)}
                style={{ display: "none", cursor: "alias" }}
                accept={"image/x-png,image/gif,image/jpeg"}
              />

              <TextField
                label={"Título"}
                variant="outlined"
                onChange={this.changeTitulo}
                value={this.state.title}
                multiline
              />

              <div style={{ alignSelf: 'flex-end', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <Button onClick={this.reject} style={{ textTransform: 'none', color: 'grey' }} size="medium" variant="outlined" color='grey'>cancelar</Button>
                <Button onClick={this.accept} style={{ textTransform: 'none', fontWeight: 'bold' }} size="medium" variant="contained" color="primary">Aceitar</Button>
              </div>

              <div style={{
                display: "flex",
                backgroundColor: 'white',
                borderRadius: '10px',
                alignItems: 'center',
                paddingLeft: '5px',
              }}>
                {this.state.playing ? (
                  <Pause
                    onClick={(_) => this.togglePlay()}
                    style={{
                      width: 35,
                      height: 35,
                      cursor: "pointer",
                      fontSize: 45,
                      float: "left",
                      borderRadius: '50px',
                      backgroundColor: palette.primary.main,
                      color: 'white',
                      marginRight: '10px'
                    }}
                  />
                ) : (
                  <PlayArrow
                    onClick={(_) => this.togglePlay()}
                    style={{
                      width: 35,
                      height: 35,
                      fontSize: 45,
                      cursor: "pointer",
                      borderRadius: '50px',
                      backgroundColor: palette.primary.main,
                      color: 'white',
                      marginRight: '10px'
                    }}
                  />
                )}

                <div
                  style={{
                    width: "100%",
                    verticalAlign: "top",
                    marginRight: 10,
                    marginTop: 18,
                  }}
                >
                  <div className={"progress"} onClick={this.changeTime}>
                    <div style={{ width: this.state.progressbar + "%", color: 'red' }}></div>
                  </div>
                  <div className={"time_run"} style={{ float: "left" }}>
                    {this.state.tempo_atual}
                  </div>
                  <div className={"time_total"} style={{ float: "right" }}>
                    {this.state.tempo_total}
                  </div>
                  <ReactAudioPlayer
                    ref={(element) => {
                      this.player = element;
                    }}
                    src={this.state.audioUrl}
                    onCanPlay={() =>
                      this.setState({
                        tempo_total: this.mmss(this.player.audioEl.duration),
                      })
                    }
                  />
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', rowGap: '6px' }}>
                <h3 style={{ color: 'grey' }}>Status:</h3>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                  <Chip style={{ color: 'grey', fontWeight: 'bold' }} variant="outlined" label="Em Aprovação" icon={this.state.podcast.status != 2 ? <CheckCircleIcon style={{ color: 'green' }} /> : <RadioButtonUnchecked />} />
                  <Chip style={{ color: 'grey', fontWeight: 'bold' }} variant="outlined" label="Concluído" icon={this.state.podcast.status == 2 ? <CheckCircleIcon style={{ color: 'green' }} /> : <RadioButtonUnchecked />} />
                </div>
              </div>

              <TextField
                label={"Código de Implantação"}
                variant="outlined"
                value={iframecode}
                multiline
                InputProps={{
                  readOnly: true,
                }}
                onClick={(evt) => {
                  evt.target.select()
                  navigator.clipboard.writeText(iframecode)
                }}
              />
            </Paper>
          </Grid>

          <Grid style={{ marginTop: isMobile ? '0px' : '160px', display: 'flex', flexDirection: 'column', gap: '30px', zIndex: 1 }} item xs={12} sm={12} md={8} lg={9} xl={9}>
            <h2 style={{ color: palette.primary.main }}>Dados do desempenho</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <h2>Geral</h2>
              <div style={{ display: 'flex', rowGap: '20px', columnGap: '5%', flexWrap: 'wrap' }}>
                {this.buildCompleteAnalyticsCard('Reproduções', this.state.totalReproducao, 'Número de vezes que o seu áudio foi reproduzido.', PlayIcon)}
                {this.buildCompleteAnalyticsCard('Compartilhamento', this.state.totalShare, 'Número de vezes que seu conteúdo foi compartilhado.', ShareIcon)}
                {this.buildCompleteAnalyticsCard('Download', this.state.totalDownload, 'Número de vezes em que seu conteúdo foi baixado', DownloadIcon)}
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px', marginBottom: '3px' }}>
                <h2>Performance nos agregadores e Redes Sociais</h2>
                {(this.state.podcast.agregar ?? false) == false &&
                  <Button onClick={() => this.publicarAgregadores()} variant="contained" color="primary" style={{ fontWeight: 'bold', textTransform: 'none' }}>Publicar nos Agregadores</Button>
                }
              </div>
              <div style={{ display: 'flex', rowGap: '20px', columnGap: '6%', flexWrap: 'wrap' }}>
                {this.buildSimpleAnalyticsCard('Spotify', this.state.openPlaySpotify, 'reproduções', SpotifyIcon)}
                {this.buildSimpleAnalyticsCard('Itunes', this.state.openPlayItunes, 'reproduções', ItunesIcon)}
                {this.buildSimpleAnalyticsCard('Google Podcast', this.state.openPlayGoogle, 'reproduções', GoogleIcon)}
                {this.buildSimpleAnalyticsCard('Whatsapp', this.state.shareWhatsapp, 'reproduções', WhatsappIcon)}
                {this.buildSimpleAnalyticsCard('Facebook', this.state.shareFacebook, 'reproduções', FacebookIcon)}
                {this.buildSimpleAnalyticsCard('Twitter', this.state.shareTwitter, 'reproduções', TwitterIcon)}
                {this.buildSimpleAnalyticsCard('Linkedin', this.state.shareLinkedin, 'reproduções', LinkedinIcon)}
              </div>
            </div>
          </Grid>
        </Grid>

      </div >
    );
  }
}

export default withStyles(useStyles)(Details);
